import { defaultDatasetConfiguration } from "@cxp-shared/metadata/src/DataSources/MetadataStoreDataverseDataSourceUtils";
var staticBindingEntitiesKey = "staticBindingEntities";
export var updateStaticBindingList = function (entities) {
    localStorage.setItem(staticBindingEntitiesKey, JSON.stringify(entities));
};
export var getStaticBindingList = function () {
    return new Set(JSON.parse(localStorage.getItem(staticBindingEntitiesKey)) || defaultDatasetConfiguration);
};
